<script>
/* eslint-disable max-len */
import "./signinCss";
import moment from "moment";
import { sDs } from "@common/sDs/sDs";
import { componentStore } from "@common/componentStore/componentStore";
import { library } from "@common/library/library";
import rosterCmp from "@signin/roster.vue";
import { controlStore, createStoreIndex } from "@common/control/controlStore.js";
import { signinStore } from "@signin/signinStore";
import VueTouchKeyboard from "@common/keyboard/keyboard";
import messagePanel from "../common/messagePanel";
import { mapState } from "vuex";

const keyboardLayouts = {
    "numeric": {
        _meta: {
            "backspace": { func: "backspace" },
            "accept": { func: "accept", text: "Enter" },
            "zero": { key: "0" }
        },

        default: [
            "1 2 3",
            "4 5 6",
            "7 8 9",
            "{zero} {backspace} {accept}"
        ]
    }
};

const editorSettings = {
    rosterId: {
        type: 'dropdown',
        id: 'rosterId',
        itemsSource: 'componentStore.getList(true)',
        itemsFilter: '"roster" === this.item.cType',
        fields: { text: 'cId', value: 'cId' },
        label: 'Roster Component',
        helpText: 'ID of roster component that should be used on Login page.',
        default: 'roster_signin'
    },
    messageId: {
        type: 'dropdown',
        id: 'messageId',
        itemsSource: 'componentStore.getList(true)',
        itemsFilter: '"messagePanel" === this.item.cType',
        fields: { text: 'cId', value: 'cId' },
        label: 'Message Component',
        helpText: 'ID of Message Panel component that should be used on Login page. If nothing is selected, settings from the Administrative Options will be used.',
        default: 'messagePanel_signin'
    }
};

let signinLoginConfig = {
    cId: "signinLogin",
    cType: "signinLogin",
    cTitle: "Sign In Login",
    cTemplate: `<div class="signin-login container signin-css" v-show="!alreadyLogged">
                    <div class="col-xs-12 col-sm-12 col-md-12 pb20">
                        <control name="SIS_LOGO"></control>
                    </div>
                    <div class="col-xs-10 col-sm-10 col-md-10 pb20 station-pane m0a" id="stationPane">
                        <div :class="permanentKeyboard ? 'col-md-7 fl' : ''">
                            <h1 class="ac mb0 mt10"><control name="SIS_NAME"></control></h1>
                        </div>
                        <div class="clearfix"></div>
                        <div v-show="!stationConfigured">
                            <div v-if="isNotConfiguredByGeo">
                                <control name="STATION_NOT_CONFIGURED_BY_GEO_MESSAGE"></control>
                            </div>
                            <div v-else>
                                <control name="STATION_NOT_CONFIGURED_MESSAGE"></control>
                            </div>
                        </div>
                        <div v-show="stationConfigured">
                            <div v-if="!permanentKeyboard" class="col-xs-6 col-sm-6 col-md-4 col-lg-3 fr other-options" v-show="controls['SIS_ALLOW_OTHER_SIGNIN_METHOD'].value == 1">
                                <control name="SIS_SIGNIN_METHOD"></control>
                            </div>
                            <div class="clearfix"></div>
                            <div :class="permanentKeyboard ? 'col-md-7 fl station-with-keyboard' : 'col-xs-12 col-sm-12 col-md-6 m0a'">
                                <div v-if="permanentKeyboard">
                                    <div class="fr other-options" v-show="controls['SIS_ALLOW_OTHER_SIGNIN_METHOD'].value == 1">
                                        <control name="SIS_SIGNIN_METHOD"></control>
                                    </div>
                                    <div class="clearfix"></div>
                                    <br/>
                                </div>
                                <div>
                                    <control name="CURRENT_TIME"></control>
                                </div>
                                <div>
                                    <control name="CURRENT_DATE"></control>
                                </div>
                                <div v-if="showMessage" class="signin-global-message">
                                    <message-panel :c-id="config.messageId || 'messagePanel_signin'"></message-panel>
                                </div>
                                <div v-if="controls['ERROR'].value">
                                    <control name="ERROR"></control>
                                </div>
                                <div v-show="controls['SIS_SIGNIN_METHOD'].value != 6">
                                    <div v-show="controls['SIS_SIGNIN_METHOD'].value == 1">
                                        <control name="VOL_USERNAME"></control>
                                        <control name="VOL_PASSWORD"></control>
                                    </div>
                                    <div v-show="controls['SIS_SIGNIN_METHOD'].value == 2">
                                        <control name="VOL_EMAIL"></control>
                                    </div>
                                    <div v-show="controls['SIS_SIGNIN_METHOD'].value == 3">
                                        <control name="VOL_DRIVER_LICENSE"></control>
                                    </div>
                                    <div v-show="controls['SIS_SIGNIN_METHOD'].value == 4">
                                        <control name="VOL_ID"></control>
                                    </div>
                                    <div v-show="controls['SIS_SIGNIN_METHOD'].value == 7">
                                        <div v-if="useBarcode">
                                            <div v-if="barcodeClearing">
                                                <p class="alert alert-danger ac">Please wait...</p>
                                            </div>
                                            <div v-else class="barcode-label">
                                                Scan your badge to begin.
                                            </div>
                                        </div>
                                        <div v-if="!useBarcode">
                                            <control name="VOL_SPECIFIC"></control>
                                        </div>
                                        <div v-if="useBarcode">
                                            <control name="VOL_SPECIFIC" :id="'barcode_id_input'" ></control>
                                        </div>
                                        <div v-if="useBarcode">
                                            <control name="CLEAR_BARCODE"></control>
                                        </div>
                                    </div>
                                    <div v-show="controls['SIS_SIGNIN_METHOD'].value == 8">
                                        <div v-show="guestNotFound == 1">
                                            <control name="NEW_VOL_FIRST_NAME"></control>
                                            <control name="NEW_VOL_LAST_NAME"></control>
                                        </div>
                                        <div>
                                            <control name="NEW_VOL_EMAIL"></control>
                                        </div>
                                    </div>
                                    <div v-if="!useBarcode && !permanentKeyboard">
                                        <control name="VOL_LOGIN"></control>
                                    </div>
                                </div>
                            </div>
                            <div v-if="permanentKeyboard && keyboardInput" :class="controls['SIS_ALLOW_OTHER_SIGNIN_METHOD'].value == 1 ? 'col-md-5 fl signin-keyboard-wrapper' : 'col-md-5 fl'">
                                <vue-touch-keyboard id="numericKeyboard" :layout="keyboardLayout" :input="keyboardInput" :accept="keyboardAccept" />
                            </div>
                            <div class="clearfix"></div>
                            <div v-if="controls['SIS_SIGNIN_METHOD'].value == 6">
                                <roster :cId="config.rosterId || 'roster_signin'" :prop-station-id="stationId"></roster>
                            </div>
                        </div>
                    </div>
                </div>
                `,
    controls: [
        {
            name: 'VOL_USERNAME',
            type: "string",
            label: "DD.SIGNIN2_OPTIONS.VOL_USERNAME",
            ref: 'VOL_USERNAME',
            required: true
        },
        {
            name: 'NEW_VOL_FIRST_NAME',
            type: "string",
            label: "DD.SIGNIN2_OPTIONS.VOL_FIRST_NAME",
            required: true,
        },
        {
            name: 'NEW_VOL_LAST_NAME',
            type: "string",
            label: "DD.SIGNIN2_OPTIONS.VOL_LAST_NAME",
            required: true,
        },
        {
            name: 'VOL_PASSWORD',
            type: 'password',
            label: "DD.SIGNIN2_OPTIONS.VOL_PASSWORD",
            required: true,
        },
        {
            name: 'VOL_LOGIN',
            type: "button",
            label: "DD.SIGNIN2_OPTIONS.VOL_LOGIN",
            onclick: "volunteerLogin",
            cssClass: "e-info"
        },
        {
            name: 'SIS_SIGNIN_METHOD',
            type: "dropdown",
            placeholder: "Other Sign In methods",
            fields: { value: "value", text: "text" },
            onchange: "clearValues",
            showClearButton: false
        },
        {
            name: 'VOL_SPECIFIC',
            type: "string",
            ref: 'VOL_SPECIFIC',
            oninput: "barCodeLogin",
            label: ""
        },
        {
            name: 'CLEAR_BARCODE',
            type: "button",
            onclick: "clearBarcode",
            label: "Click here if your badge doesn't scan",
            cssClass: "e-link"
        },
        {
            name: 'VOL_EMAIL',
            type: "string",
            ref: 'VOL_EMAIL',
            label: "DD.SIGNIN2_OPTIONS.VOL_EMAIL",
            required: true,
            format: "",
            rules: [
                /* istanbul ignore next */ function (v) {
                    if (/.+@.+\..+/.test(v)) return true;
                    return "Email must be valid";
                }
            ],
        },
        {
            name: 'NEW_VOL_EMAIL',
            type: "string",
            label: "DD.SIGNIN2_OPTIONS.VOL_EMAIL",
            ref: 'NEW_VOL_EMAIL',
            required: true,
            format: "",
            rules: [
                /* istanbul ignore next */ function (v) {
                    if (/.+@.+\..+/.test(v)) return true;
                    return "Email must be valid";
                }
            ],
        },
        {
            name: 'VOL_DRIVER_LICENSE',
            type: "string",
            required: true,
            label: "DD.SIGNIN2_OPTIONS.VOL_DRIVER_LICENSE",
        },
        {
            name: 'VOL_ID',
            type: "string",
            required: true,
            label: "DD.SIGNIN2_OPTIONS.VOL_ID",
        },
        {
            name: 'SIS_LOGO',
            type: "image",
            cssClass: "sis-logo col-xs-4 col-sm-4 col-md-4"
        },
        {
            name: 'SIS_NAME',
            asField: true,
            type: "string",
            value: "Sign-In Station"
        },
        {
            name: 'CURRENT_TIME',
            asField: true,
            type: "date",
            format: "LTS"
        },
        {
            name: 'CURRENT_DATE',
            asField: true,
            type: "date",
            format: "D MMM YYYY"
        },
        {
            name: 'STATION_NOT_CONFIGURED_MESSAGE',
            asField: true,
            value: "DD.SIGNIN2_OPTIONS.STATION_NOT_CONFIGURED_MESSAGE",
            type: "info"
        },
        {
            name: 'STATION_NOT_CONFIGURED_BY_GEO_MESSAGE',
            asField: true,
            value: "The location of your device is out of range for this station. Please contact your volunteer coordinator for more information.",
            type: "info"
        },
        {
            name: 'ERROR',
            asField: true,
            type: "error",
            value: ""
        },
        {
            name: 'INFO',
            asField: true,
            type: "info",
            value: ""
        },
        {
            name: 'WARNING',
            asField: true,
            type: "info",
            value: ""
        },
        {
            name: 'SIS_ALLOW_OTHER_SIGNIN_METHOD',
            asField: true,
            type: "boolean",
            value: false
        }
    ],
    components: {
        roster: {
            cId: 'roster_signin'
        },
        signInOut: {
            cId: 'signInOut_signin'
        }
    },
    layoutDatamap: [
        {
            "property": "volunteerLoggedIn", "from": "signinLogin", "to": "thisStore", "as": "volunteerLoggedIn"
        }
    ],
    useBarcode: false
};

let signinLoginCmp = {
    name: 'signinLogin',
    preInitControls: true,
    editorSettings: editorSettings,
    props: {
        staticId: {
            default: true
        }
    },
    data: function () {
        return {
            volunteerLoggedIn: false,
            guestNotFound: null,
            lastAction: false,
            timeouts: {},
            barcodeClearing: false,
            useBarcode: false,
            keyboardInput: false,
            showMessage: false,
            onLoadExecuted: false,
            alreadyLogged: true
        };
    },
    components: {
        'roster': rosterCmp,
        'messagePanel': messagePanel,
        'vue-touch-keyboard': VueTouchKeyboard
    },
    watch: {
        stationConfigured: function (value, prevValue) {
            if (prevValue === false && value === true && !this.onLoadExecuted) {
                this.onLoadExecuted = true;
                this.onLoad();
            }
        }
    },
    computed: {
        ...mapState('signinStore', ['isNotConfiguredByGeo', 'isConfigured']),
        signinStore() {
            return signinStore.state;
        },
        stationConfigured() {
            return this.isConfigured;
        },
        stationId() {
            return signinStore.state.stationId;
        },
        permanentKeyboard() {
            let pkMethod = 7;
            return signinStore.state.permanentKeyboard && !library.isMobile() && this.controls && this.controls['SIS_SIGNIN_METHOD'] && parseInt(this.controls['SIS_SIGNIN_METHOD'].value, 10) === pkMethod;
        },
        keyboardLayout() {
            return keyboardLayouts['numeric'];
        },
    },
    methods: {
        keyboardAccept() {
            this.volunteerLogin();
        },
        processAction(act) {
            switch (act) {
                case 'trapEnter':
                    this.volunteerLogin();
                    break;
            }
        },
        barCodeLogin() {
            if (this.useBarcode) {
                this.volunteerLogin();
                this.clearBarcode();
            }
        },
        clearBarcode() {
            this.barcodeClearing = true;
            setTimeout(() => {
                if (this.controls['VOL_SPECIFIC'].value.length) {
                    this.controls['VOL_SPECIFIC'].value = '';
                    this.focusLoginElement();
                }
                this.barcodeClearing = false;
            }, 1000); // NOSONAR
        },
        onClick: function () {
            this.lastAction = new Date().getTime() / 1000; // NOSONAR
        },
        returnToDefaultSignInMethod: /* istanbul ignore next */ function (loopSeconds) {
            if (!this.cId || !this || this === null) return;
            loopSeconds = parseInt(loopSeconds, 10);
            if (isNaN(loopSeconds) || loopSeconds < 1) return;

            let currCheck = new Date().getTime() / 1000; // NOSONAR
            if (this.timeouts === null) {
                return;
            }
            if (typeof this.timeouts["returnToDefaultSignInMethod"] !== "undefined") {
                clearTimeout(this.timeouts["returnToDefaultSignInMethod"]);
                delete this.timeouts["returnToDefaultSignInMethod"];
            }
            if ((currCheck - this.lastAction) >= loopSeconds) {
                this.clearValues();
            }
            if (typeof this.timeouts === 'object' && this.timeouts !== null) {
                this.timeouts["returnToDefaultSignInMethod"] = setTimeout(() => {
                    if (this && this.returnToDefaultSignInMethod) this.returnToDefaultSignInMethod(loopSeconds);
                }, loopSeconds * 1000); // NOSONAR
            }
        },
        onLoad: async function () {
            this.lastAction = new Date().getTime() / 1000; // NOSONAR
            if (this.stationConfigured) {
                library.showLoadingIndicator('body');
                let loggedReq = await sDs.post('er_getLoggedUsers', 'vol');
                library.hideLoadingIndicator('body');
                if (loggedReq.status === 'success' && parseInt(loggedReq.data, 10) > 0) {
                    this.alreadyLogged = true;
                    this.volunteerLogin(true);
                    return;
                }
                this.alreadyLogged = false;
                this.onLoadExecuted = true;
                this.clearValues();
                let controlKeys = Object.keys(this.signinStore.controls);
                controlKeys.forEach((key) => {
                    let control = this.signinStore.controls[key];
                    if (this.controlConfigs[key]) {
                        control = { ...this.controlConfigs[key], ...control };
                    }
                    if (!control.name) control.name = key;
                    let controlStoreIndex = createStoreIndex(this.storeId, control.name);
                    controlStore().addControl(control, this, controlStoreIndex);
                });
                if (this.config.messageId && this.config.messageId !== 'messagePanel_signin') {
                    this.showMessage = true;
                }
                if (this.controls['SIO_MESSAGE'] && this.controls['SIO_MESSAGE'].value) {
                    let messagePanelConfig = await componentStore.getConfig('messagePanel_signin');
                    messagePanelConfig.customMessageTemplate = this.controls['SIO_MESSAGE'].value;
                    componentStore.mutateComponent('messagePanel_signin', messagePanelConfig);
                    this.showMessage = true;
                }
                if (!this.controls['SIS_LOGO'].value) this.controls['SIS_LOGO'].value = this.signinStore.controls['SIS_LOGO'].value;
                if (typeof THE_CUSTOMER !== 'undefined' && THE_CUSTOMER === 'AMNH' && this.controls['SIS_SPECIFIC_AUTH'].value === "402155") {
                    this.useBarcode = true;
                }
                if (this.accountSettings && typeof this.accountSettings['ACCOUNT_TIME_ZONE'] !== 'undefined' && (typeof this.accountSettings['SIO_TIMEZONE_BROWSER'] === 'undefined' || this.accountSettings['SIO_TIMEZONE_BROWSER'] !== '1')) {
                    let accountTz = parseInt(this.accountSettings['ACCOUNT_TIME_ZONE'], 10);
                    if (accountTz) {
                        accountTz *= 60; // NOSONAR
                        let localTz = moment().utcOffset();
                        this.controls['CURRENT_TIME'].addMinutes = accountTz - localTz;
                        this.controls['CURRENT_DATE'].addMinutes = accountTz - localTz;
                    }
                }
                this.onClick();
                document.addEventListener("click", this.onClick);
                document.addEventListener("keydown", this.onClick);
                this.returnToDefaultSignInMethod(this.controls["SIS_SUPERVISIOR_TIMEOUT"].value);
                this.focusLoginElement();
                this.showKeyboard();
            }
        },
        showKeyboard() {
            if (this.controls && this.controls['SIS_SIGNIN_METHOD'] && parseInt(this.controls['SIS_SIGNIN_METHOD'].value, 10) === 7) { // NOSONAR
                setTimeout(() => {
                    if (this.refs && this.refs['VOL_SPECIFIC'] && this.refs['VOL_SPECIFIC'].element) {
                        this.keyboardInput = this.refs['VOL_SPECIFIC'].element;
                    } else {
                        this.showKeyboard();
                    }
                }, 500); // NOSONAR
            }
        },
        focusLoginElement: function () {
            let isUnit = library.getCookie("isUnit");
            if (isUnit) return;
            let signInMethod = this.controls['SIS_SIGNIN_METHOD'].value;
            let elementId = '';

            switch (signInMethod) {
                case "1":
                    elementId = 'VOL_USERNAME';
                    break;
                case "2":
                    elementId = 'VOL_EMAIL';
                    break;
                case "7":
                    elementId = 'VOL_SPECIFIC';
                    break;
                case "8":
                    elementId = 'NEW_VOL_EMAIL';
                    break;
            }
            if (elementId && this.refs && this.refs[elementId]) {
                this.$nextTick(() => {
                    this.refs[elementId].element.focus();
                });
            } else {
                setTimeout(() => {
                    this.focusLoginElement();
                }, 500); // NOSONAR
            }
        },
        clearValues: function (event) {
            if (!this.stationId) return;
            this.controls['ERROR'].value = "";
            this.controls['WARNING'].value = "";
            this.controls['VOL_USERNAME'].value = "";
            this.controls['NEW_VOL_FIRST_NAME'].value = "";
            this.controls['NEW_VOL_LAST_NAME'].value = "";
            this.controls['VOL_PASSWORD'].value = "";
            this.controls['VOL_SPECIFIC'].value = "";
            this.controls['VOL_EMAIL'].value = "";
            signinStore.set('isGuest', false);
            if (!event) {
                signinStore.set('volunteer', false);
                this.volunteerLoggedIn = false;
                this.controls['SIS_SIGNIN_METHOD'].value = this.controls['SIS_SIGNIN_METHOD'].default;
            }
            this.showKeyboard();
            this.focusLoginElement();
        },
        volunteerLogin: async function (useLogged) {
            if (!this.stationId) return;
            let signInMethod = useLogged === true ? 99 : this.controls["SIS_SIGNIN_METHOD"].value;
            if (!signInMethod) return;
            let username = "";
            let password = "";
            let credential = "";
            let controls = [];
            let error = false;
            let errorMsg = [];
            let loginType;
            let guestFields = {};
            this.controls['ERROR'].value = '';
            switch (parseInt(signInMethod, 10)) {
                case 1:
                    loginType = "UIDPW";
                    controls = ["VOL_USERNAME", "VOL_PASSWORD"];
                    username = this.controls["VOL_USERNAME"].value;
                    password = this.controls["VOL_PASSWORD"].value;
                    break;
                case 2: // NOSONAR
                    loginType = "email";
                    controls = ["VOL_EMAIL"];
                    credential = this.controls["VOL_EMAIL"].value;
                    break;
                case 7: // NOSONAR
                    loginType = "specific_" + this.controls["SIS_SPECIFIC_AUTH"].value;
                    controls = ["VOL_SPECIFIC"];
                    credential = this.controls["VOL_SPECIFIC"].value;
                    break;
                case 8: // NOSONAR
                    loginType = "email";
                    controls = ["NEW_VOL_EMAIL"];
                    guestFields['CONTACT_TYPE#7'] = this.controls["NEW_VOL_EMAIL"].value;
                    if (this.guestNotFound) {
                        controls.push("NEW_VOL_FIRST_NAME");
                        controls.push("NEW_VOL_LAST_NAME");
                        guestFields['VOL_FIRST_NAME'] = this.controls["NEW_VOL_FIRST_NAME"].value;
                        guestFields['VOL_LAST_NAME'] = this.controls["NEW_VOL_LAST_NAME"].value;
                    }
                    break;
                case 99:
                    loginType = 'logged';
            }
            for (let i in controls) {
                if (i === 'length') continue;
                let controlName = controls[i];
                if (this.controls[controlName].validationErrors && this.controls[controlName].validationErrors.length) {
                    errorMsg = errorMsg.concat(this.controls[controlName].validationErrors);
                    error = true;
                }
            }
            /* istanbul ignore next */
            if (error) {
                this.controls['ERROR'].value = errorMsg.join("\n");
                return;
            }

            if (signInMethod === "8") {
                library.showLoadingIndicator('body');
                this.sDs.post('er_SISCreateGuest', guestFields).then((response) => {
                    library.hideLoadingIndicator('body');
                    if (response && response.data && (response.data.volId || response.data.volId === 0)) {
                        signinStore.set('isGuest', true);
                        if (response.data.volId === 0) {
                            this.guestNotFound = 1;
                        } else {
                            this.guestNotFound = 0;
                            this.controls['SIS_SIGNIN_METHOD'].value = "2";
                            this.controls['VOL_EMAIL'].value = guestFields['CONTACT_TYPE#7'];
                            this.volunteerLogin();
                        }
                    } else {
                        this.guestNotFound = 0;
                        this.controls['SIS_SIGNIN_METHOD'].value = "2";
                        this.controls['VOL_EMAIL'].value = guestFields['CONTACT_TYPE#7'];
                        this.volunteerLogin();
                    }
                });
                return;
            }
            library.showLoadingIndicator('body');
            this.sDs.post("er_getSISDetails", loginType, username, password, credential, this.signinStore.fields.sch, this.signinStore.fields.vol, this.signinStore.isGuest).then((response) => {
                library.hideLoadingIndicator('body');
                /* istanbul ignore next */
                if ((response && response.data && response.data.status && response.data.status === "Failure") || (response && response.status !== 'success')) {
                    // eslint-disable-next-line no-nested-ternary
                    let sisErrorMsg = response.data && response.data.message ? response.data.message : (response.error ? response.error.join(" ") : "The credentials you provided are incorrect. Please try again.");
                    this.controls['ERROR'].value = sisErrorMsg;
                    return;
                }
                if (response && response.status === 'success' && response.data) {
                    this.volunteerLoggedIn = true;
                    if (
                        typeof this.controls['SIS_LOCATION_ACCURACY'] !== 'undefined'
                        && this.controls['SIS_LOCATION_ACCURACY'].value
                        && (this?.controls?.['SIS_USE_OPP_COORD']?.value || this?.controls?.['SIS_USE_ORG_COORD']?.value)
                    )
                    {
                        let browserLat = this.signinStore.browserLat;
                        let browserLng = this.signinStore.browserLng;
                        for (let ssIndex in response.data.volSlots) {
                            if (ssIndex === 'length') continue;
                            let lat;
                            let lng;
                            if (this?.controls?.['SIS_USE_OPP_COORD']?.value) {
                                if (typeof lat === 'undefined' || lat === '0' || lat === '') {
                                    lat = response.data.volSlots[ssIndex].OPP_LOC_LATITUDE;
                                }
                                if (typeof lng === 'undefined' || lng === '0' || lng === '') {
                                    lng = response.data.volSlots[ssIndex].OPP_LOC_LONGITUDE;
                                }
                            }
                            if (this?.controls?.['SIS_USE_ORG_COORD']?.value) {
                                if (typeof lat === 'undefined' || lat === '0' || lat === '') {
                                    lat = response.data.volSlots[ssIndex].ORG_CONTACT_LATITUDE;
                                }
                                if (typeof lng === 'undefined' || lng === '0' || lng === '') {
                                    lng = response.data.volSlots[ssIndex].ORG_CONTACT_LONGITUDE;
                                }
                            }
                            if (typeof lat !== 'undefined'
                                && typeof lng !== 'undefined'
                                && lat !== '0'
                                && lng !== '0'
                                && lat !== ''
                                && lng !== ''
                                && (!this.signinStore.geolocationEnabled || library.geolocation.getDistanceFromLatLonInM(lat, lng, browserLat, browserLng) > 100)
                            ) {
                                response.data.volSlots.splice(ssIndex, 1);
                            }
                        }
                        for (let oppIndex in response.data.volOpps) {
                            if (oppIndex === 'length') continue;
                            let lat;
                            let lng;
                            if (this?.controls?.['SIS_USE_OPP_COORD']?.value) {
                                if (typeof lat === 'undefined' || lat === '0' || lat === '') {
                                    lat = response.data.volOpps[oppIndex].OPP_LOC_LATITUDE;
                                }
                                if (typeof lng === 'undefined' || lng === '0' || lng === '') {
                                    lng = response.data.volOpps[oppIndex].OPP_LOC_LONGITUDE;
                                }
                            }
                            if (this?.controls?.['SIS_USE_ORG_COORD']?.value) {
                                if (typeof lat === 'undefined' || lat === '0' || lat === '') {
                                    lat = response.data.volOpps[oppIndex].ORG_CONTACT_LATITUDE;
                                }
                                if (typeof lng === 'undefined' || lng === '0' || lng === '') {
                                    lng = response.data.volOpps[oppIndex].ORG_CONTACT_LONGITUDE;
                                }
                            }
                            if (typeof lat !== 'undefined'
                                && typeof lng !== 'undefined'
                                && lat !== '0'
                                && lng !== '0'
                                && lat !== ''
                                && lng !== ''
                                && (!this.signinStore.geolocationEnabled || library.geolocation.getDistanceFromLatLonInM(lat, lng, browserLat, browserLng) > 100)
                            ) {
                                response.data.volOpps.splice(oppIndex, 1);
                            }
                        }
                    }
                    if (!response?.data?.volOpps?.length && !response?.data?.volSlots?.length) {
                        response.data.volFields['VOL_SIGNED_IN'] = 'No';
                    }
                    signinStore.set('volunteer', response.data);
                    this.clearValues(true);
                    this.controls['SIS_SIGNIN_METHOD'].value = this.controls['SIS_SIGNIN_METHOD'].default;
                }
            });
        }
    },
    unmounted() {
        document.removeEventListener("click", this.onClick);
        document.removeEventListener("keydown", this.onClick);
        for (let i in this.timeouts) {
            if (i === 'length') continue;
            clearTimeout(this.timeouts[i]);
        }
    }
};
componentStore.initComponent(signinLoginCmp, signinLoginConfig, '@signin/signinLogin.vue');
export { signinLoginConfig, signinLoginCmp };
export default signinLoginCmp;

</script>

<style scoped>
#numericKeyboard {
    position: relative;
    width: 250px;
    border: none;
    box-shadow: none;
}

.p40 {
    padding: 40px;
}

.station-with-keyboard {
    padding: 0px 40px 40px 40px;
}

.signin-keyboard-wrapper {
    margin-top: 5px;
}

.mt-20 {
    margin-top: -20px;
}

:deep(#numericKeyboard.vue-touch-keyboard .key) {
    width: 58px;
    height: 58px;
    line-height: 58px;
    font-weight: bold;
    font-size: 25px;
    box-shadow: none;
    border-color: black;
    border-radius: 5px;
}

:deep(#numericKeyboard.vue-touch-keyboard .key.accept) {
    font-size: 20px;
}

.other-options {
    min-width: 250px;
}

:deep(#numericKeyboard.vue-touch-keyboard .keyboard .key.backspace) {
    background-image:url(data:image/svg+xml;base64,PHN2ZyBpZD0iU3ZnanNTdmcxMDAxIiB3aWR0aD0iMjg4IiBoZWlnaHQ9IjI4OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWxuczpzdmdqcz0iaHR0cDovL3N2Z2pzLmNvbS9zdmdqcyI+PGRlZnMgaWQ9IlN2Z2pzRGVmczEwMDIiPjwvZGVmcz48ZyBpZD0iU3ZnanNHMTAwOCIgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsMSwwLDApIj48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjI4OCIgaGVpZ2h0PSIyODgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTAgMGg0OHY0OGgtNDh6Ij48L3BhdGg+PHBhdGggZmlsbD0iIzAwMDAwMCIgZD0iTTQ0IDZoLTMwYy0xLjM4IDAtMi40Ny43LTMuMTkgMS43NmwtMTAuODEgMTYuMjMgMTAuODEgMTYuMjNjLjcyIDEuMDYgMS44MSAxLjc4IDMuMTkgMS43OGgzMGMyLjIxIDAgNC0xLjc5IDQtNHYtMjhjMC0yLjIxLTEuNzktNC00LTR6bS02IDI1LjE3bC0yLjgzIDIuODMtNy4xNy03LjE3LTcuMTcgNy4xNy0yLjgzLTIuODMgNy4xNy03LjE3LTcuMTctNy4xNyAyLjgzLTIuODMgNy4xNyA3LjE3IDcuMTctNy4xNyAyLjgzIDIuODMtNy4xNyA3LjE3IDcuMTcgNy4xN3oiIGNsYXNzPSJjb2xvcmZmZiBzdmdTaGFwZSI+PC9wYXRoPjwvc3ZnPjwvZz48L3N2Zz4=);
}

:deep(.e-control *) {
    font-size: 18px !important;
}

:deep(.date-time) {
    font-family: 'Syncopate',sans-serif;
    font-size: 2.5em;
    margin: 0;
    text-align: center;
    width: 100%;
    display: block;
}

:deep([id^="SIS_NAME"] *) {
    color: #337ab7;
    font-weight: bold;
    font-size: 2.3em !important;
    line-height: 1em;
}

:deep([id^="VOL_LAST_NAME"] *) {
    font-weight: bold;
}

:deep([id^="VOL_FIRST_NAME"] *) {
    font-weight: bold;
}

:deep(.sis-logo) {
    width: 360px;
    margin: 0 auto;
    display: block;
}

:deep(.barcode-label) {
    text-align: center;
    font-size: 20px;
}

:deep(#barcode_id_input) {
    position: fixed;
    top: -100px;
}

:deep(.privacy-policy a) {
    text-decoration: none;
    color: #337ab7;
    font-weight: bold;
}
</style>
